export const apiCreate = (): string => '/partnerships/routesAgencies/'
export const apiList = (id?: string): string =>
  !id
    ? '/partnerships/routesAgencies/'
    : `/partnerships/routesAgencies/view/${id}`
export const apiGetByIdUpdatePage = (id: string): string =>
  `/partnerships/routesAgencies/getByIdUpdatePage/${id}`
export const apiUpdate = (id: string): string =>
  `/partnerships/routesAgencies/update/${id}`
export const apiDelete = (id: string): string =>
  `/partnerships/routesAgencies/${id}`
